import { Button } from '@speeki/global-ui-components';

import error_image from '@assets/images/error.png';
import nicole_poster_3 from '@assets/images/nicole_poster_3.png';

import { ContainerInner } from '@components/_global/GlobalStyle/Global.styled';
import { Container } from '@components/ions/layouts';
import { DefaultLayout } from '@components/templates/DefaultLayout/DefaultLayout';

import {
    ErrorCard,
    ErrorImage,
    ErrorText,
    StyledContainerSection,
    StyledImage,
    StyledText,
    StyledTitle,
} from './ErrorPageTemplate.styled';

interface ErrorPageTemplateProps {
    buttonText: string;
    descriptionText: string;
    isNicole: boolean;
    isNotFound?: boolean;
    onClick?: () => void;
    titleText: string;
}

export const ErrorPageTemplate = ({
    buttonText,
    descriptionText,
    isNicole,
    isNotFound,
    onClick,
    titleText,
}: ErrorPageTemplateProps) => {
    return (
        <DefaultLayout>
            <Container>
                <ContainerInner>
                    <StyledContainerSection>
                        <ErrorCard>
                            {isNotFound ? (
                                <ErrorText>404</ErrorText>
                            ) : (
                                <ErrorImage
                                    alt="ErrorImage"
                                    src={error_image}
                                />
                            )}
                            <StyledTitle>{titleText}</StyledTitle>
                            <StyledText>{descriptionText}</StyledText>
                            <Button
                                onClick={onClick}
                                testId="eUpS1Sz"
                                variant={'primary'}
                            >
                                {buttonText}
                            </Button>
                        </ErrorCard>
                        {isNicole && (
                            <StyledImage
                                alt={'nicole poster'}
                                src={nicole_poster_3}
                            />
                        )}
                    </StyledContainerSection>
                </ContainerInner>
            </Container>
        </DefaultLayout>
    );
};
